const REPEATER_DELIMITER = '__'

const getTemplateIdAndItemContext = (id: string) => id.split(REPEATER_DELIMITER)
const isRepeatedItemOverrideId = (id: string) => id.includes(REPEATER_DELIMITER)
const createRepeatedItemOverrideId = (id: string, context: string) => `${id}${REPEATER_DELIMITER}${context}`

export { getTemplateIdAndItemContext, isRepeatedItemOverrideId, createRepeatedItemOverrideId }
